module.exports = __webpack_public_path__ + "static/media/New Ways to Work with FormIt Pro and Dynamo.6bb104b2.png";